// src/models/enums/GenderEnum.ts

export enum GenderEnum {
  FEMALE = "FEMALE",
  MALE = "MALE",
  OTHER = "OTHER",
  UNSPECIFIED = "UNSPECIFIED"
}

// Turkish display labels
export const GenderLabels: Record<GenderEnum, string> = {
  [GenderEnum.FEMALE]: "Kadın",
  [GenderEnum.MALE]: "Erkek",
  [GenderEnum.OTHER]: "Diğer",
  [GenderEnum.UNSPECIFIED]: "Belirtmek İstemiyorum"
};